<template>
    <div>
        <card>
            <div class="row" style="margin-left:5px">
                <button @click="modals.mini = true" class="btn float-left" type="button" style="margin-top:10px;background:#00467f">Cerca Azienda</button>
            </div>
            <h3 style="margin-top:10px;margin-left:5px">Nota di Credito</h3>
            <hr>
            <form v-if="idNota == null">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="ufficio">Ufficio<span style="color:#ff0000">*</span></label>
                        <select id="ufficio" v-model="ufficio" class="form-control">
                            <option v-for="valori in sedi" v-bind:key="valori.ID" :value="valori.ID" v-on:change="getRichiedenti(valori.ID)">{{valori.DENOMINAZIONE}} - {{valori.UFFICIO}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="cognome_nome_richiedente">Cognome e nome richiedente nota di credito<span style="color:#ff0000">*</span></label>
                        <input type="text" class="form-control" id="cognome_nome_richiedente" v-model="cognome_nome_richiedente">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="codice_fiscale">Codice Fiscale<span style="color:#ff0000">*</span></label>
                        <input type="text" class="form-control" id="codice_fiscale" v-model="codice_fiscale" placeholder="codice fiscale">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputAddress">Denominazione<span style="color:#ff0000">*</span></label>
                        <input type="text" class="form-control" v-model="denominazione" id="denominazione" placeholder="denominazione">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="numero_fattura">Numero Fattura<span style="color:#ff0000">*</span></label>
                        <input type="numer" class="form-control" v-model="numero_fattura" id="numero_fattura" placeholder="123">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="data_fattura">Data Fattura<span style="color:#ff0000">*</span></label>
                        <input type="date" class="form-control" v-model="data_fattura" id="data_fattura" >
                    </div>
                </div>
                <div class="form-row justify-content-cente">
                    <div class="form-group col-md-4">
                        <!-- if storno parziale => compare importo 
                            se check storno totale non viene fuori
                         -->
                        <div style="margin-top:30px;margin-bottom:10px">
                            <label class="label-switch">Storno parziale</label>
                            <label class="switch" style="margin-top:10px">
                                <input type="checkbox" class="form-control" v-model="storno_intero" style="margin-top:20px"><span class="slider round"></span>
                            </label>
                            <label  class="label-switch">Stornare intera fattura</label>
                        </div>
                    </div>
                    <div class="form-group col-md-4" v-if="!storno_intero">
                        <label for="importo">Importo<span style="color:#ff0000">*</span></label>
                        <div class="input-icon">
                            <!-- <input type="text" class="form-control" placeholder="0.00"> -->
                            <input type="number" class="form-control" v-model="importo" id="importo" placeholder="0.00">
                            <i>€</i>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="metodo_importo">Modalità pagamento della fattura<span style="color:#ff0000">*</span></label>
                        <select v-model="metodo" class="form-control">
                            <option value="contanti">Contanti</option>
                            <option value="bonifico">Bonifico</option>
                            <option value="sepa">SEPA</option>
                            <option value="pos">POS</option>
                        </select>
                    </div>
                   
                </div>
                <!-- <div class="form-row">
                
                </div> -->
                <div class="form-row  justify-content-center">
                    <!-- <div class="form-group col-md-3">
                        <label class="form-check-label" for="storno" style="margin-top:30px"><input class="form-check-input" type="checkbox" id="storno" v-model="if_storno">Storno</label>
                    </div> -->
                    <div class="form-group col-4">
                        <label class="form-check-label" for="urgente">Emissione Urgente<input class="form-control" type="checkbox" id="urgente" v-model="urgente"></label>
                    </div>
                    <div class="form-group col-md-8" v-if="urgente">
                        <label for="data_ultima_emissione">Termine ultimo emissione nota<span style="color:#ff0000">*</span></label>
                        <input type="date" class="form-control" v-model="data_ultima_emissione" id="data_ultima_emissione">  
                    </div>
                    <div class="form-group col-md-8" v-else></div>
                </div> 
                <div class="form-row">
                    
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="causale_nota">Causale nota<span style="color:#ff0000">*</span></label>
                        <!-- <input type="text" class="form-control" v-model="causale_nota" id="causale_nota" style="width:100%;height:100px;" readonly> -->
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="causale_nota" id="causale_nota" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>                    
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="erroreCausatoDa">Cognome e nome persona che ha causato l'errore<span style="color:#ff0000">*</span></label>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="erroreCausatoDa" id="erroreCausatoDa" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>                    
                    </div>
                    <div class="form-group col-md-6">
                        <label for="motivazione">Motivazione dell'errore<span style="color:#ff0000">*</span></label>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="motivazione" id="motivazione" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>                    
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="azioneIntrapresa">Azioni intraprese per non ripetere lo stesso errore<span style="color:#ff0000">*</span></label>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="azioneIntrapresa" id="azioneIntrapresa" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>                    
                    </div>
                </div>
                
                <!-- <div class="form-row">
                    <div class="form-group">
                        <label for="file">Carica scansione fattura</label><br>
                        <button class="btn" style="margin-left:10px;font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()"></button>
                    </div>
                </div> -->
                <button type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaValori()">Salva</button>
                <!-- <div class="col"> -->
                <router-link to="/note-credito" class="btn float-right" style="margin-right:10px;background:#00467f">Indietro</router-link>
                <!-- </div> -->
                <button v-if="user_livello == 1" type="button" class="btn float-left" style="background:#00467f" v-on:click="cancellaNota()">Cancella Nota</button>
            </form>
        </card>
        
        <modal :show.sync="modals.mini"
                :show-close="false"
                header-classes="justify-content-center"
                type="mini"
                style="position:fixed;overflow: auto;"><!--vertical-align: middle;overflow: auto; transform: translateY(-40%) -->
            <div class="modal-profile d-flex">
                <!--<i class="nc-icon nc-watch-time"></i>-->
                <button class="btn float-left" @click="modals.mini = false" style="background:#00467f;"><i class="tim-icons icon-simple-remove" ></i></button>
            </div>
            <label for="cerca_azienda"><strong>NOME AZIENDA </strong></label>
            <input class="form-control" type="text" placeholder="Nome azienda" name="cerca_azienda" v-model="cerca_azienda" v-on:change="cercaInfo()">
            <label for="cerca_codice_fiscale"><strong>CODICE FISCALE </strong></label>
            <input class="form-control" type="text" placeholder="Codice fiscale" name="cerca_codice_fiscale" v-model="cerca_codice_fiscale" v-on:change="cercaInfo()">
            <label for="cerca_p_iva"><strong>PARTITA IVA</strong></label>
            <input class="form-control" type="text" placeholder="Partita iva" name="cerca_p_iva" v-model="cerca_p_iva" v-on:change="cercaInfo()">
            <template slot="footer">
            <!-- tabella con i risultati -->
            <div v-show="showRisultati">
                <div v-if="cerca_info.length>0">
                <table class="table tablesorter" style="text-align: center;">
                    <thead>
                    <tr>
                        <th>AZIENDA</th>
                        <th>CF</th>
                        <th>P. IVA</th>
                        <th>SEDE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(valori,index) in cerca_info" v-bind:key="valori.ID">
                        <td style="text-decoration:underline"><a v-on:click="compilaForm(index)">{{valori.name}}</a></td>
                        <td>{{valori.crm_cf_c}}</td>
                        <td>{{valori.crm_piva_c}}</td>
                        <td>{{valori.billing_address_street}}, {{valori.billing_address_city}} ({{valori.billing_address_state}}) {{valori.billing_address_postalcode}}</td><!--infoAzienda.billing_address_street + ", " + infoAzienda.billing_address_city + " (" + infoAzienda.billing_address_state + ") " +infoAzienda.billing_address_postalcode -->
                    </tr>
                    </tbody>
                </table>
                </div>
                <div v-else>
                <div class="text-center" v-if="!nessunRisulato">
                    <!-- <circle-10></circle-10> -->
                </div>
                <div v-else>
                    <p>Nessun risultato trovato</p>
                </div>
                    <!--<p>Nessun risultato trovato</p>-->
                </div>
            </div>
            </template>
        </modal>

        <!--  MODAL CARICARE FILE -->
        <!-- <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal> -->

    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import {Modal} from '@/components';
import Services from '@/services/Services';
import NoteServices from '@/services/NoteServices';


export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            modals: {
                mini: false
            },
            //form
            cognome_nome_richiedente: null,
            ufficio: null,
            richiedente_nota: null,
            dipendenti_richiedenti: [],
            codice_fiscale: null,
            denominazione: null,
            numero_fattura: null,
            data_fattura: null,
            // addebiti_stornare: null,
            causale_nota: null,
            storno_intero: true,
            importo: null,
            metodo: null,
            // motivazione: null,
            data_ultima_emissione: null,
            // if_storno: false,
            emissione: false,
            urgente: false,
            autorizzazione_emissione: null,
            sedi: [],
            file: null,
            showCheckFile: false,
            showLoader: false,
            fileCaricati: [],

            erroreCausatoDa: null,
            motivazione: null,
            azioneIntrapresa: null,

            //pop up per cercare 
            showRisultati: false,
            nessunRisulato: false,
            cerca_azienda: '',
            cerca_codice_fiscale: '',
            cerca_p_iva: '',
            cerca_info: [],
            denominazione_search: null,
            codice_fiscale_search: null,
            partita_iva_search: null,

            idNota: null,
            showDelete: false,
            confermaCancella: false,
            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'   //'https://apiintranet.confcom.it/'
        }
    },
    methods: {
        cercaInfo: async function() {
            let errore = 0;
            const token = localStorage.getItem('access_token');
            await Services.searchInformation(this.cerca_azienda, this.cerca_codice_fiscale, this.cerca_p_iva)
            .then(response => { this.cerca_info = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                errore = error.response.status;
                }
            })
            if (errore == 401) {
            let value =  await Services.refreshTokenFunction();
            if (value) { await this.cercaInfo(); }
            }
            this.showRisultati = true;
            if (this.cerca_info.length == 0) {
            this.nessunRisulato = true;
            }
        },

        checkData: function() {
            if (this.ufficio == null || this.cognome_nome_richiedente == null || this.codice_fiscale == null || this.denominazione == null
                    || this.numero_fattura == null || this.data_fattura == null 
                    || this.causale_nota == null || this.metodo == null
                    ||  this.erroreCausatoDa == null || this.motivazione == null || this.azioneIntrapresa == null
                ) {
               return fale;
            } else {
               if (this.urgente == true) {
                    if (this.data_ultima_emissione == null) 
                        return false;
                    else  
                        return true
                } else if(!this.storno_intero) {
                    if (this.importo == null) {
                        return false;
                    } else {
                        return true;
                    }
                }
                else {
                    return true;
                }
            }
        },

        compilaForm: function(index){
            let infoAzienda = this.cerca_info[index];
            this.denominazione = infoAzienda.name;
            this.codice_fiscale = infoAzienda.crm_cf_c;
        },

        getSedi: async function(){
            let errore = 0;
            await Services.getSedi()
            .then(response => { this.sedi = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value =  await Services.refreshTokenFunction();
                if (value) { await this.getSedi(); }
            }
        },

        getRichiedenti: async function(idSede) {
            console.log(`getRichiedenti()`);
            // GET /users?filter=true&sede=:idsede
            let errore = 0;
            await NoteServices.getRichiedenti(idSede)
            .then(response => { this.dipendenti_richiedenti = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getRichiedenti(); }
            }
            console.log(`dipendenti richiedenti`);
            console.log(this.dipendenti_richiedenti);
        },
            
        // refreshToken: async function() {
        //     let errore = 0;
        //     await Services.refreshToken()
        //     .then(response => { this.token_response = response.data})
        //     .catch(function (error) {
        //         // handle error
        //         if(error.response.status == 403){
        //             errore = error.response.status;
        //         } else if (error.response.status == 401) {
        //             errore = error.response.status;
        //         }
        //     });
        //     console.log(`errore fuori da catch refreshToken = ${errore}`);
        //     if(errore == 403 || errore == 401){
        //         console.log(`errore = ${errore} -> fai logout`);
        //         await this.logout();
        //         return false;
        //     } 
        //     localStorage.setItem('access_token', this.token_response.accessToken);
        //     return true;
        // },

        salvaValori: async function() {
            // ufficio codice_fiscale denominazione numero_fattura  data_fattura importo  metodo  data_ultima_emissione urgente  emissione  causale_nota
            if (!this.checkData()) {
                alert("compilare tutti i dati");
            } else {
                console.log(`salvaValori`);
                let id_user = localStorage.getItem('user_id');
                let dati = []; 
                let errore = 0;
                // if (this.idNota == null || this.idNota == '') {
                let response_dati = [];
                console.log(`ID_USER: ${id_user},  ID_UFFICIO: ${this.ufficio}, CF: ${this.codice_fiscale}, DENOMINAZIONE_DITTA: ${this.denominazione}, N_FATTURA: ${this.numero_fattura}, data_fattura: ${this.data_fattura},
                    CAUSALE_NOTA: ${this.causale_nota}, IMPORTO: ${this.importo},  METODO_IMPORTO: ${this.metodo}, DATA_ULTIMA_EMISSIONE: ${this.data_ultima_emissione}, URGENTE: ${this.urgente}`); // MOTIVAZIONE: ${this.motivazione}

                dati.push({ 
                    ID_USER: id_user, ID_UFFICIO: this.ufficio, RICHIEDENTE: this.cognome_nome_richiedente, CF: this.codice_fiscale, DENOMINAZIONE_DITTA: this.denominazione, N_FATTURA: Number(this.numero_fattura), DATA_FATTURA: this.data_fattura, EMISSIONE: this.emissione,
                    CAUSALE_NOTA: this.causale_nota, IMPORTO: Number(this.importo),  METODO_IMPORTO: this.metodo, DATA_ULTIMA_EMISSIONE: this.data_ultima_emissione, URGENTE: this.urgente,
                    ERRORE_CAUSATO_DA: this.erroreCausatoDa, MOTIVAZIONE: this.motivazione, AZIONE_INTRAPRESA: this.azioneIntrapresa 
                });
                let datiJSON = JSON.stringify(dati[0]);
                console.log(dati);
                console.log(datiJSON);
                // se null crea nota
                await NoteServices.createNota(datiJSON)
                .then(response => { response_dati = response.data})
                .catch(function (error) {
                    // handle error
                    if(error.response.status == 401){
                        errore = error.response.status;
                    }
                })
                if(errore == 401){
                    let value =  await Services.refreshTokenFunction();
                    if (value) { await this.salvaValori(); }
                }
                console.log(`idNota dopo aver salvato: ${response_dati.ID}`);
                this.$router.push({
                    // path: '/note-credito'
                    path: `/uploadfile-nota?id=${response_dati.ID}`
                })
            }
        },

        main: async function() {
            this.idNota = this.$route.query.id;
            console.log(`idNota=${this.idNota}.`);
            this.access_token = localStorage.getItem('access_token');
            axios.defaults.withCredentials = true;
            try {
                await this.getSedi();
                // if (this.idNota != null && this.idNota != '') {
                //     await this.caricaNota();
                // }
            } catch (error) {
                if (error.response.status == 401) {
                    await Services.refreshTokenFunction();
                }
            }
            
        }
    },

    mounted() {
        
    },
    beforeMount() {
        this.main();
    }
  };
</script>
<style scoped>
/* body {
    margin: 10px; 
     padding: 10px;
} */
form {
    /* max-width: 580px; */
    margin: auto;
}

label {
    font-size: 16px;
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

.label-switch {
    position: relative;
  /* display: inline-block; */
  display: table-cell;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 14px;
}
.switch {
  position: relative;
  /* display: inline-block; */
  display: table-cell;
  width: 55px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 0px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #00467f;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00467f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
</style>
  